import { onDomReady } from '../utils/dom';

/**
 * @type {HTMLElement|null}
 */
let root = null;

/**
 * @type {HTMLElement|null}
 */
let inside = null;

/**
 * @type {HTMLElement|null}
 */
let container = null;

/**
 * Header height in the initial (non-sticky) state. Measured while the header is not sticky and
 * remembered afterwards: a fixed header shrinks (compact bar), a header that overlays the page
 * (position: absolute) does not push the next element down at all, so its offsetTop is 0.
 * @type {number}
 */
let baseHeight = 0;

// Get the height of the header: top offset of the next element or, for an overlaying header, its own height.
export const getHeight = () => {
    if (!root.classList.contains('sticky')) {
        baseHeight = Math.max(container.offsetTop, root.offsetHeight);
    }

    return baseHeight.toFixed(0);
};

// Get the current height of header_inside.
export const getInnerHeight = () => inside.getBoundingClientRect().height.toFixed(1);

// Get the position from which the header should be fixed.
export const getFixedPosition = () => window.innerHeight / 2;

function showFixedHeader() {
    const scrolledTop = document.documentElement.scrollTop;
    const classList = root.classList;

    if (scrolledTop > Number.parseInt(getHeight())) {
        classList.add('sticky');

        if (classList.contains('menu-open') || classList.contains('level-open')) {
            classList.add('keep');
        }

        if (scrolledTop > getFixedPosition()) {
            classList.add('show');
        } else {
            classList.replace('show', 'hide');
        }
    } else {
        classList.remove('sticky', 'hide', 'keep', 'show');
    }
}

onDomReady(() => {
    root = document.querySelector('#header');
    inside = root.querySelector('.header_inside');
    container = document.querySelector('#header + div');

    showFixedHeader();
});

window.addEventListener('scroll', () => {
    showFixedHeader();
});

window.addEventListener('resize', () => {
    showFixedHeader();
});
